module.exports = __webpack_public_path__ + "static/andreas_sahle-4bb5b730c58ea8095954a50e120c7189.png";